import { useMemo } from 'react'

import { ArticleList, IArticleListItem } from 'src/components/molecules'

import { IInsightEntity } from '../types'

interface IInsightsMobileListProps {
  insights: IInsightEntity[]
  onInsightClick?: (insight: IInsightEntity) => void
}

const formatMeta = (insight: IInsightEntity): string =>
  `${insight.category} · ${insight.producer} · ${insight.releaseDate}`

export const InsightsMobileList = ({
  insights,
  onInsightClick,
}: IInsightsMobileListProps): JSX.Element => {
  const items: IArticleListItem[] = insights.map(
    (insight): IArticleListItem => ({
      id: insight.id,
      title: insight.reportName,
      meta: formatMeta(insight),
    }),
  )

  const insightsById = useMemo(
    (): Map<string, IInsightEntity> =>
      new Map(
        insights.map((insight): [string, IInsightEntity] => [
          insight.id,
          insight,
        ]),
      ),
    [insights],
  )

  const handleItemClick = onInsightClick
    ? (item: IArticleListItem): void => {
        const insight = insightsById.get(item.id)
        if (insight) {
          onInsightClick(insight)
        }
      }
    : undefined

  return (
    <ArticleList
      items={items}
      ariaLabel="Member insights"
      onItemClick={handleItemClick}
    />
  )
}
